import { useState } from 'react';

import StarsList from './starList.component';
import { StarRatingProvider } from './starRatingContext';
import { StarRatingLabel } from './starRatingLabel.component';

// export const StarRatingContext = createContext();
interface IStarRating {
  defaultState: number;
  emptyColor: string;
  fillColor: string;
  height: number;
  labelText: (value: number) => React.ReactNode;
  maxValue: number;
  onChangeHover: (value: number | null) => void;
  onChangeValue: (value: number) => void;
  readOnly: boolean;
  width: number;
}
export default function StarRating({
  defaultState,
  emptyColor,
  fillColor,
  height,
  labelText,
  maxValue,
  onChangeHover,
  onChangeValue,
  readOnly,
  width,
}: IStarRating) {
  const [rating, setRating] = useState(defaultState);
  const [hover, setHover] = useState<number | null>(null);

  const setRatingFn = (value: number) => {
    if (readOnly) return;

    setRating(value);
    onChangeValue(value);
  };

  const setHoverFn = (value: number | null) => {
    if (readOnly) return;

    setHover(value);
    onChangeHover(value);
  };

  return (
    <>
      <StarRatingProvider
        value={{
          emptyColor,
          fillColor,
          height,
          hover,
          labelText,
          rating,
          setHover: setHoverFn,
          setRating: setRatingFn,
          width,
          maxValue,
        }}
      >
        <>
          <StarRatingLabel />
          <StarsList />
        </>
      </StarRatingProvider>
    </>
  );
}
